"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaFilesController = void 0;
class MediaFilesController {
    constructor(config) {
        this.thumbnailUrl = config.thumbnailUrl;
        this.videoThumbnailUrl = config.videoThumbnailUrl;
        this.s3Url = config.s3Url;
    }
    getWidthHeight(width, height, exactSize) {
        let imageWidth, imageHeight;
        if (exactSize) {
            imageWidth = typeof width === "number" ? width : 0;
            imageHeight = height === "auto" ? 0 : height;
        }
        else {
            const size = this.getThumbnailSize(width === "auto" ? 0 : width, height === "auto" ? 0 : height);
            imageWidth = size.width;
            imageHeight = size.height;
        }
        return {
            imageWidth,
            imageHeight,
        };
    }
    getImageThumbnail(urlPart, width, height = "auto", opts = {}) {
        const { imageWidth, imageHeight } = this.getWidthHeight(width, height, !!opts.exactSize);
        return `${this.thumbnailUrl}/${urlPart}/${imageWidth}/${imageHeight}/fit/ce`;
    }
    getVideoThumbnail(urlPart, width, height = "auto", opts = {}) {
        const { imageWidth, imageHeight } = this.getWidthHeight(width, height, !!opts.exactSize);
        return `${this.videoThumbnailUrl}/${urlPart}/${imageWidth}/${imageHeight}/fit/ce`;
    }
    getVideoUrl(urlPart) {
        return `${this.s3Url}/${urlPart}`;
    }
    getFileUrl(urlPart) {
        return `${this.s3Url}/${urlPart}`;
    }
    getThumbnailSize(widthOrCode, height = 0) {
        const getClosestSize = (goal, sizes, key) => {
            const list = Object.keys(sizes).reduce((out, resolutionKey) => {
                out[sizes[resolutionKey][key]] = sizes[resolutionKey];
                return out;
            }, {});
            const listKeys = Object.keys(list);
            const maxValue = Number(listKeys.reduce((prev, next) => (Number(prev) > Number(next) ? prev : next)));
            return listKeys.reduce((prev, currentKey) => {
                const current = {
                    value: Number(currentKey),
                    sizeInfo: list[currentKey],
                };
                const currentValue = current.value, previousValue = prev.value;
                return Math.abs(currentValue - goal) < Math.abs(previousValue - goal) &&
                    (currentValue >= goal || currentValue === maxValue)
                    ? current
                    : prev;
            }, { value: Number(listKeys[0]), sizeInfo: list[listKeys[0]] });
        };
        const sizes = {
            "240p": { width: 352, height: 240 },
            "360p": { width: 480, height: 360 },
            "480p": { width: 858, height: 480 },
            "720p": { width: 1280, height: 720 },
            "1080p": { width: 1920, height: 1080 },
        };
        if (typeof widthOrCode === "string") {
            return sizes[widthOrCode] || sizes["240p"];
        }
        const closestWidth = getClosestSize(widthOrCode, sizes, "width");
        const closestHeight = getClosestSize(height, sizes, "height");
        if (closestWidth.value > closestHeight.sizeInfo.width) {
            return closestWidth.sizeInfo;
        }
        else {
            return closestHeight.sizeInfo;
        }
    }
}
exports.MediaFilesController = MediaFilesController;
//# sourceMappingURL=MediaFilesController.js.map